import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { NavigationService } from "../../../../providers/navigation.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ITableColumnHeader } from "../../../../models/table-column-header";
import { Subscription } from "rxjs";
import { ApiService } from "../../../../providers/api.service";
import { SM_CONSTANTS } from "../../../../shared/constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { MatDialog } from "@angular/material/dialog";
import { BookingDetailsComponent } from "src/app/shared/components/booking-details/booking-details.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { AddFutureBookingsComponent } from "src/app/shared/components/add-future-bookings/add-future-bookings.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { InvoiceForFitnessComponent } from "src/app/shared/components/invoice-for-fitness/invoice-for-fitness.component";
import { InvoiceForReportOnlyComponent } from "src/app/shared/components/invoice-for-report-only/invoice-for-report-only.component";
import { CreateInvoiceForCustomersComponent } from "src/app/shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { CreateInvoiceWithoutBookingComponent } from "src/app/shared/components/create-invoice-without-booking/create-invoice-without-booking.component";
import { YoutubeEmbedVideoComponent } from "src/app/pages/new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { DialogService } from "src/app/providers/dialog.service";
import { AuthService } from "src/app/providers/auth.service";
import { AdvancePaymentSettingComponent } from "src/app/pages/new-v2-pages/new-v2-component/advance-payment-setting/advance-payment-setting.component";

@Component({
  selector: "sm-invoices-report",
  templateUrl: "./invoices-report.component.html",
  styleUrls: ["./invoices-report.component.scss"],
})
export class InvoicesReportComponent implements OnInit, OnDestroy {
  isOwner: boolean = false;

  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  selectedFrequency: any = 1;
  // frequencyOfView: any
  selectedView: any = "Data";
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  entityHashId: string = "";
  discountInfo: any = null;
  pageTitle: string = "Booking History";
  @Input() pageSubTitle: string = "";
  @Input() showBackButton: boolean = false;
  @Input("buttonText") showButton: string = "";
  @Input()
  headerCustomTemplate!: TemplateRef<any>;

  fromDate: any = new Date();
  toDate: any = new Date();
  today: string = this.formatDate1(new Date());
  invoiceReportData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "invoice_report.column_headers.date"
      ),
      columnProperty: "creation_time",
    },
    {
      columnName: this.translateService.instant(
        "invoice_report.column_headers.invoice"
      ),
      columnProperty: "invoiceNumber",
    },
    {
      columnName: this.translateService.instant(
        "invoice_report.column_headers.amount"
      ),
      columnProperty: "amount",
    },
    {
      columnName: this.translateService.instant(
        "invoice_report.column_headers.status"
      ),
      columnProperty: "pay_status",
    },
  ];

  private _apiSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    public _modelRef: MatDialog,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private authService: AuthService
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_INVOICE_REPORT) {
        this.invoiceReportData = [];
        if (true) {
          this.invoiceReportData = resData.result ? resData.result : [];
          if (this.invoiceReportData.length > 0) {
            this.invoiceReportData = resData.result.map((item: any) => {
              // Creating a new object with all the same keys and values
              const newItem = { ...item };

              // Adding a new custom key with a custom value
              newItem.pay_status = item.paymentStatus == 1 ? "Paid" : "Unpaid";

              return newItem;
            });
          }
        }

        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_INVOICE_LIST_FOR_REPORTS
      ) {
        this.invoiceReportData = [];
        if (true) {
          this.invoiceReportData = resData.result ? resData.result : [];
          if (this.invoiceReportData.length > 0) {
            this.invoiceReportData = resData.result.map((item: any) => {
              // Creating a new object with all the same keys and values
              const newItem = { ...item };

              // Adding a new custom key with a custom value
              newItem.pay_status = item.paymentStatus == 1 ? "Paid" : "Unpaid";

              return newItem;
            });
          }
        }

        this._apiService.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        if (this.isEntityForeign == "0") {
          this._apiService.getInvoiceReport(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        } else if (this.isEntityForeign == "1") {
          this._apiService.getInternationalEntityInvoiceListForReports(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (this.isEntityForeign == "0") {
          this._apiService.getInvoiceReport(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        } else if (this.isEntityForeign == "1") {
          this._apiService.getInternationalEntityInvoiceListForReports(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (this.isEntityForeign == "0") {
          this._apiService.getInvoiceReport(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        } else if (this.isEntityForeign == "1") {
          this._apiService.getInternationalEntityInvoiceListForReports(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (this.isEntityForeign == "0") {
          this._apiService.getInvoiceReport(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        } else if (this.isEntityForeign == "1") {
          this._apiService.getInternationalEntityInvoiceListForReports(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (this.isEntityForeign == "0") {
          this._apiService.getInvoiceReport(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        } else if (this.isEntityForeign == "1") {
          this._apiService.getInternationalEntityInvoiceListForReports(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (this.isEntityForeign == "0") {
          this._apiService.getInvoiceReport(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        } else if (this.isEntityForeign == "1") {
          this._apiService.getInternationalEntityInvoiceListForReports(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE_WITHOUT_BOOKING
      ) {
        if (resData.result) {
          if (this.isEntityForeign == "0") {
            this._apiService.getInvoiceReport(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.isEntityForeign == "1") {
            this._apiService.getInternationalEntityInvoiceListForReports(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_WITHOUT_BOOKING
      ) {
        if (resData.result) {
          if (this.isEntityForeign == "0") {
            this._apiService.getInvoiceReport(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.isEntityForeign == "1") {
            this._apiService.getInternationalEntityInvoiceListForReports(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE
      ) {
        if (resData.result) {
          if (this.isEntityForeign == "0") {
            this._apiService.getInvoiceReport(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.isEntityForeign == "1") {
            this._apiService.getInternationalEntityInvoiceListForReports(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_DETAILS
      ) {
        if (resData.result) {
          if (this.isEntityForeign == "0") {
            this._apiService.getInvoiceReport(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.isEntityForeign == "1") {
            this._apiService.getInternationalEntityInvoiceListForReports(
              this.entityHashId,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resData.result) {
          this.discountInfo = resData.result;
        }
        this.visible = true;
        this.loaderservice.showLoader = false;
      }
    });
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }

  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = ["date", "invoice", "amount", "status"];
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `invoice_report.column_headers.${data[index]}`
      );
    });
  }
    isAccessForEmployeeInvoice: boolean = false

  ngOnInit(): void {
        this.isOwner = this.authService.isOwner();

    sessionStorage.removeItem("mefrp");
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
    });
    // this.fromDate.setDate(this.fromDate.getDate() - 30);
    // this.fromDate = this.fromDate.toISOString().slice(0, 10);
    // this.toDate = this.toDate.toISOString().slice(0, 10);
    this.loaderservice.showLoader = true;
    this.visible = false;
 if(this.isOwner){
      this.isAccessForEmployeeInvoice = true;
    }else{

    const ssa = sessionStorage.getItem(SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS);
    const hsa = sessionStorage.getItem(SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS);
    const vsa = sessionStorage.getItem(SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS);

    const bsss = sessionStorage.getItem('shop_service_status');
    const bhss = sessionStorage.getItem('home_service_status');
    const bvss = sessionStorage.getItem('virtual_service_status');



    // sessionStorage.getItem() returns a string or null.

    // 2. Check if ANY of the retrieved values is the string '1'
    if ((ssa == '1' && bsss != '2') || (hsa == '1' && bhss != '2') || (vsa == '1' && bvss != '2')) {
      this.isAccessForEmployeeInvoice = true;
    }
    }
    if (this.isEntityForeign == "0") {
      this._apiService.getInvoiceReport(
        this.entityHashId,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else if (this.isEntityForeign == "1") {
      this._apiService.getInternationalEntityInvoiceListForReports(
        this.entityHashId,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    }
  }
  search() {
    // Ensure date range is valid based on the selected frequency
    const fromDate = new Date(this.fromDate);
    const toDate = new Date(this.toDate);

    if (this.selectedFrequency === 1) {
      // Daily
      const maxRange = 90;
      const range =
        (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
      if (range > maxRange) {
        const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "The selected time frame between from date and to date should be under 90 days.",
            okbtn: "Ok",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        return;
      }
    } else if (this.selectedFrequency === 2) {
      // Monthly
      const maxRange = 36;
      const range =
        toDate.getMonth() -
        fromDate.getMonth() +
        12 * (toDate.getFullYear() - fromDate.getFullYear());
      if (range > maxRange) {
        const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "The selected time frame between from date and to date should be under 3 years.",
            okbtn: "Ok",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
          },
          disableClose: true,
        });
        return;
      }
    }

    //end
    if (this.selectedFrequency == 2) {
      this.tableDisplayColumns = [
        {
          columnName: "date",
          columnProperty: "creation_time",
        },
        {
          columnName: "Invoice No.",
          columnProperty: "invoiceNumber",
        },
        {
          columnName: "Amount",
          columnProperty: "amount",
        },
        {
          columnName: "Payment status",
          columnProperty: "pay_status",
        },
      ];
      this.loaderservice.showLoader = true;
      this.visible = false;
      if (this.isEntityForeign == "0") {
        this._apiService.getInvoiceReport(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      } else if (this.isEntityForeign == "1") {
        this._apiService.getInternationalEntityInvoiceListForReports(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }
    } else {
      this.tableDisplayColumns = [
        {
          columnName: "date",
          columnProperty: "creation_time",
        },
        {
          columnName: "Invoice No.",
          columnProperty: "invoiceNumber",
        },
        {
          columnName: "Amount",
          columnProperty: "amount",
        },
        {
          columnName: "Payment status",
          columnProperty: "pay_status",
        },
      ];
      this.loaderservice.showLoader = true;
      this.visible = false;
      if (this.isEntityForeign == "0") {
        this._apiService.getInvoiceReport(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      } else if (this.isEntityForeign == "1") {
        this._apiService.getInternationalEntityInvoiceListForReports(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }
    }
  }

  changeFrequency() {
    if (this.selectedFrequency == 2) {
      this.tableDisplayColumns = [
        {
          columnName: "month",
          columnProperty: "month",
        },
        {
          columnName: "total sales",
          columnProperty: "totalSales",
        },
        {
          columnName: "home sales",
          columnProperty: "homeSales",
        },
        {
          columnName: "shop sales",
          columnProperty: "shopSales",
        },
      ];
      this.loaderservice.showLoader = true;
      this.visible = false;
      this._apiService.getInvoiceReport(
        this.entityHashId,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 30);
      this.fromDate = this.fromDate.toISOString().slice(0, 10);
      this.toDate = this.toDate.toISOString().slice(0, 10);
      this.tableDisplayColumns = [
        {
          columnName: "date",
          columnProperty: "date",
        },
        {
          columnName: "total sales",
          columnProperty: "totalSales",
        },
        {
          columnName: "home sales",
          columnProperty: "homeSales",
        },
        {
          columnName: "shop sales",
          columnProperty: "shopSales",
        },
      ];
      this.loaderservice.showLoader = true;
      this.visible = false;
      this._apiService.getInvoiceReport(
        this.entityHashId,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    }
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate() {
    this.router.navigate(["../"], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

  openInvoice(item: any) {
    if (item.bookingHashId) {
      let data = {
        title: "Invoice",
        ref: this._modelRef,
        data: item.bookingHashId,
      };
      this.dialogService.openFullScreenDialog(InvoiceForReportComponent, data);
    } else {
      let data1 = {
        title: "Invoice",
        ref: this._modelRef,
        data: item.hash_id,
        entityHash: this.entityHashId,
      };
      this.dialogService.openFullScreenDialog(
        InvoiceForReportOnlyComponent,
        data1
      );
    }
  }

  formatDate1(dateStr: Date) {
    console.log(dateStr);

    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);
    console.log(curdate);

    return curdate;
  }

  createInvoice() {
    let data = {
      title: "New Invoice",
      ref: this._modelRef,
      data: {
        entityHash: this.entityHashId,
        // serviceType: this.bookingType,
        discountInfo: this.discountInfo,
      },
    };
    this.dialogService.openFullScreenDialog(
      CreateInvoiceWithoutBookingComponent,
      data
    );
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }
  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/WnQJt38uyKI",
        title: "Generating Bills & Invoices in LookzUp Web Portal. ",
      },
    });
  }
  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

   openaadvancepaymentsetup() {
    this.loaderservice.showLoader = true;
    let data = {
      entityHash: this.entityHashId,

    }
    this.dialogService.openFullScreenDialog(AdvancePaymentSettingComponent,data)
  }
}
